import styled from '@emotion/styled';
import React from 'react';

import completedIcon from 'src/public/img/icon-completed.svg';
import lockIconBlue from 'src/public/img/icon-lock-blue.svg';
import { color, font } from '../styles/variables';

const Wrapper = styled.div(() => ({
    padding: '10px 10px 10px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 6,
    marginBottom: 35,
    maxWidth: 215,
    width: '100%',
    cursor: 'pointer',
    border: `2px solid ${color.catskillWhite}`,
    transition: 'all 0.2s ease-in-out',
    justifyContent: 'space-between',
    '&:hover': {
        borderColor: color.royalBlueSaturated,
    },
    position: 'relative',
}));

const Image = styled.img({
    width: '100%',
});

const ContentWrapper = styled.div({
    marginTop: 12,
});

const Title = styled.p(
    {
        color: color.pickledBluewood,
        marginBottom: 5,
        lineHeight: '20px',
    },
    font.heavy(font.size.mediumExtended),
);

const Info = styled.span(
    {
        color: color.ebonyClay,
    },
    font.book(15),
);

const InfoSeparator = styled.span(
    {
        color: color.ebonyClay,
    },
    font.book(13),
);

const Icon = styled.img({
    position: 'absolute',
    width: 20,
    height: 20,
    left: 'auto',
    right: 12,
    top: 12,
});

interface Props {
    title: string;
    image: string;
    firstInfoText: string;
    secondInfoText: string;
    onClick: () => void;
    slug?: string;
    isCompleted?: boolean;
    isLocked?: boolean;
}

export enum ContentCardTestId {
    Completed = 'ContentCardTestId.Completed',
    Locked = 'ContentCardTestId.Locked',
}

export const ContentCard: React.FC<Props> = ({
    title,
    image,
    firstInfoText,
    secondInfoText,
    onClick,
    slug,
    isLocked,
    isCompleted,
}) => {
    let applyBorderRadiusToImg = false;
    if (slug) {
        applyBorderRadiusToImg = slug.indexOf('the-reset') >= 0;
    }

    return (
        <Wrapper onClick={onClick}>
            {isLocked && <Icon data-testid={ContentCardTestId.Locked} src={lockIconBlue} />}
            {isCompleted && <Icon data-testid={ContentCardTestId.Completed} src={completedIcon} />}
            <Image src={image} style={{ borderRadius: applyBorderRadiusToImg ? 5 : 0 }} />

            <ContentWrapper>
                <Title>{title}</Title>
                <div>
                    <Info>{firstInfoText}</Info>
                    <InfoSeparator>{' • '}</InfoSeparator>
                    <Info>{secondInfoText}</Info>
                </div>
            </ContentWrapper>
        </Wrapper>
    );
};
